import React from 'react';
import { CONTAINER_PREFIX } from '../../constants';

type Props = {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  children?: never;
};

const CaptchaContainer: React.FC<Props> = (props) => {
  const { name, className, style } = props;

  return <div className={className} style={style} id={`${CONTAINER_PREFIX}${name}`} />;
};

export default React.memo(CaptchaContainer);
